import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { CdssAppointmentModel, UserViseAppointmentModel } from '../business-entities/user-vise-appointment-model';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class UserViseAppointmentDataService {

  constructor(private dataProvider: DataService) { }
  getUserViseAppointmentList(requestModel: any) {
    return this.dataProvider.Post<GenericResponse<Array<UserViseAppointmentModel>>>(Urls.GetUserViseAppointmentList, requestModel).toPromise();
}

getCdssAppointmentList(requestModel: any) {
  return this.dataProvider.Post<GenericResponse<Array<CdssAppointmentModel>>>(Urls.GetCdssAppointmentList, requestModel).toPromise();
}
}
